export enum SearchEngine {
	Baidu = 'baidu',
	Bing = 'bing',
	DuckDuckGo = 'duckduckgo',
	Google = 'google',
	Seznam = 'seznam',
	Yahoo = 'yahoo',
	Yandex = 'yandex',
}
